/**
* 报告运行状态
*/
export const PREPARE_RUN = 0
export const RUNNING = 1
export const SUCCESS = 2
export const FAIL = 3

/**
* azf质检状态
*/
export const SUCCESS_QUALITY = 0
export const CONTROL_FAIL_QUALITY = 1
export const CASE_FAIL_QUALITY = 2

/**
 * array-pgt结构变异select选项
 */

export const TRANINFOS_OPTION = [
  { label: 'null', value: 'null' },
  { label: '平衡易位', value: 'trans' },
  { label: '倒位', value: 'inv' },
  {label: '罗氏易位', value: 'rob'},
  { label: '其它', value: 'other' },
]
export const Range_OPTION = [
  { label: 'null', value: 'null' },
  { label: '男', value: 'delF' },
  { label: '女', value: 'delM' },
 
]

/**
 * array-pgt 家系信息范围select选项
 */

export const RANGES_OPTION = [
  { label: '2000000', value: '2000000' },
  { label: '3000000', value: '3000000' },
  { label: '4000000', value: '4000000' },
  { label: '5000000', value: '5000000' },
  { label: '6000000', value: '6000000' },
]

/**
 * array-pgt 家系信息染色体select选项
 */
export const CHROMOSOMES_OPTION = [
  { label: 'chr1', value: 'chr1' },
  { label: 'chr2', value: 'chr2' },
  { label: 'chr3', value: 'chr3' },
  { label: 'chr4', value: 'chr4' },
  { label: 'chr5', value: 'chr5' },
  { label: 'chr6', value: 'chr6' },
  { label: 'chr7', value: 'chr7' },
  { label: 'chr8', value: 'chr8' },
  { label: 'chr9', value: 'chr8' },
  { label: 'chr10', value: 'chr10' },
  { label: 'chr11', value: 'chr11' },
  { label: 'chr12', value: 'chr12' },
  { label: 'chr13', value: 'chr13' },
  { label: 'chr14', value: 'chr14' },
  { label: 'chr15', value: 'chr15' },
  { label: 'chr16', value: 'chr16' },
  { label: 'chr17', value: 'chr17' },
  { label: 'chr18', value: 'chr18' },
  { label: 'chr19', value: 'chr19' },
  { label: 'chr20', value: 'chr20' },
  { label: 'chr21', value: 'chr21' },
  { label: 'chr22', value: 'chr22' },
  { label: 'chrX', value: 'chrX' },
  { label: 'chrY', value: 'chrY' },
]

/**
 * array pgt 家系信息芯片类型select选项
 */
export const CHIPTYPES_OPTION = [
  { label: 'HumanCytoSNP_ISCAN', value: 'HumanCytoSNP_ISCAN' },
  { label: 'humankaryomap_ISCAN', value: 'humankaryomap_ISCAN' },
  { label: 'HumanCytoSNP_NS550', value: 'HumanCytoSNP_NS550' },
  { label: 'HumanKaryomap_NS550', value: 'HumanKaryomap_NS550' },
  { label: 'ASA-24v1_ISCAN', value: 'ASA-24v1_ISCAN' },
  { label: 'GSA-24v3_ISCAN', value: 'GSA-24v3_ISCAN' },
  { label: 'CytoSNP-850K_ISCAN', value: 'CytoSNP-850K_ISCAN' },
]

export const TRANINFO_DEFAULT_OBJECT = {
  type: 'null',
  name: '',
  breakpoint: '',
  chromosome: '',
  startPosition: '',
  endPosition: '',
  chromosome2: ''
}
export const Range_TRANINFO_DEFAULT_OBJECT = {
    gender: 'null',
    chromosome: '',
    startPosition: '',
    endPosition: '',
}
export const ARRAY_PGT_FILE_TYPE = [
  'Report_Gene_Mutation.txt',
  'Report_Del_Region_Depth.txt',
  'Report_Haplotype.txt',
  'Report_effective_snp_sta.txt',
  'Report_Haplotype_GT.2.xls',
  'Report_Target_Region_Depth.txt',
  'Report_chrY-Depth.txt',
  'Report_Haplotype_GT.mini.xls'
]

export const ROB_OPTIONS = [
  { label: 'chr13', value: 'chr13' },
  { label: 'chr14', value: 'chr14' },
  { label: 'chr15', value: 'chr15' },
  { label: 'chr21', value: 'chr21' },
  { label: 'chr22', value: 'chr22' },
]

export const CHROMOSOME_OPTIONS = [
  { label: 'chr1', value: 'chr1' },
  { label: 'chr2', value: 'chr2' },
  { label: 'chr3', value: 'chr3' },
  { label: 'chr4', value: 'chr4' },
  { label: 'chr5', value: 'chr5' },
  { label: 'chr6', value: 'chr6' },
  { label: 'chr7', value: 'chr7' },
  { label: 'chr8', value: 'chr8' },
  { label: 'chr9', value: 'chr9' },
  { label: 'chr10', value: 'chr10' },
  { label: 'chr11', value: 'chr11' },
  { label: 'chr12', value: 'chr12' },
  { label: 'chr13', value: 'chr13' },
  { label: 'chr14', value: 'chr14' },
  { label: 'chr15', value: 'chr15' },
  { label: 'chr16', value: 'chr16' },
  { label: 'chr17', value: 'chr17' },
  { label: 'chr18', value: 'chr18' },
  { label: 'chr19', value: 'chr19' },
  { label: 'chr20', value: 'chr20' },
  { label: 'chr21', value: 'chr21' },
  { label: 'chr22', value: 'chr22' },
  { label: 'chrX', value: 'chrX' },
  { label: 'chrY', value: 'chrY'},
]


// WEBPACK FOOTER //
// ./src/app/utils/const.js